import React, { Component } from "react";
import { Button, Input, Row, Col, Alert, Spinner } from "reactstrap";
import img_phone from "../public/images/phone.png";
import img_google from "../public/images/google.png";
import img_facebook from "../public/images/facebook.png";
import img_linkedin from "../public/images/linkedin.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperPlane, faEraser } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import Fade from "react-reveal/Fade";
import Bounce from "react-reveal/Bounce";
import { APPFBASE } from "../firebase";

class Contact extends Component {
  constructor(props) {
    super(props);
    var sessionUser = window.sessionStorage.getItem("uName");

    this.state = {
      sessionUser: sessionUser !== null ? sessionUser : "",
      inputNameErr: "",
      inputMailErr: "",
      inputMessageErr: "",
      inputMailErrMsg: "",
      alertVisible: false,
      alertMessage: "",
      alertClass: "",
      isSending: false,
    };
  }

  handleSubmit = async () => {
    var inputName = document.getElementById("contact-name").value.trim();
    var inputMail = document.getElementById("contact-email").value.trim();
    var inputMessage = document.getElementById("contact-message").value.trim();

    var inputNameErr = false;
    var inputMailErr = false;
    var inputMessageErr = false;

    if (/^ *$/.test(inputName)) {
      inputNameErr = true;
      this.setState({
        inputNameErr: "startpage-input-error",
      });
    }

    if (/^ *$/.test(inputMail)) {
      inputMailErr = true;
      this.setState({
        inputMailErr: "startpage-input-error",
        inputMailErrMsg: "Please enter your email",
      });
    } else if (!/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}/.test(inputMail)) {
      inputMailErr = true;
      document.getElementById("contact-email").value = "";
      this.setState({
        inputMailErr: "startpage-input-error",
        inputMailErrMsg: "Please enter a valid email",
      });
    }

    if (/^ *$/.test(inputMessage)) {
      inputMessageErr = true;
      this.setState({
        inputMessageErr: "startpage-input-error",
      });
    }

    if (!inputNameErr && !inputMailErr && !inputMessageErr) {
      if (this.state.alertVisible) {
        this.setState({
          alertVisible: false,
        });
      }

      this.setState({
        isSending: true,
      });

      var sessionUser = window.sessionStorage.getItem("uName");
      let userMsgData = {
        sessionName: window.sessionStorage.getItem("uName"),
        name: inputName,
        email: inputMail,
        message: inputMessage,
      };

      const MESSAGES_REF = APPFBASE.COLLECTIONS.MESSAGES;

      await MESSAGES_REF.add({
        ...userMsgData,
        date: moment().format("YYYY-MM-DD"),
      }).then(() => {
        this.setState({
          isSending: false,
        });
      });

      document.getElementById("contact-email").value = "";
      document.getElementById("contact-message").value = "";

      this.setState({
        sessionUser: sessionUser !== null ? sessionUser : "",
        inputNameErr: "",
        inputMailErr: "",
        inputMessageErr: "",
        inputMailErrMsg: "",
        alertVisible: true,
        alertMessage: "Your message has been sent. Thank you!",
        alertClass: "success",
      });
    }
  };

  handleClear = () => {
    document.getElementById("contact-name").value = "";
    document.getElementById("contact-email").value = "";
    document.getElementById("contact-message").value = "";

    if (this.state.alertVisible) {
      this.setState({
        alertVisible: false,
      });
    }

    this.setState({
      sessionUser: "",
      inputNameErr: "",
      inputMailErr: "",
      inputMessageErr: "",
      inputMailErrMsg: "",
    });
  };

  render() {
    return (
      <div
        className="contact-container text-center component-top-margin ml-auto mr-auto"
        id="contact"
      >
        <Bounce>
          <div>
            <h1 className="common-component-title">CONTACT ME</h1>
            <h4 className="mt-5 mb-5 main-text-color">
              I'd love to hear from you. Drop me a message!
            </h4>
            <Row className="justify-content-center">
              <Col lg="6">
                <Input
                  type="text"
                  id="contact-name"
                  placeholder={
                    this.state.inputNameErr !== ""
                      ? "Please enter your name"
                      : "Name"
                  }
                  className={"shadow-none rounded-0 " + this.state.inputNameErr}
                  autoComplete="off"
                  value={this.state.sessionUser}
                  onChange={(e) =>
                    this.setState({
                      sessionUser: e.target.value,
                      inputNameErr: "",
                      alertVisible: false,
                    })
                  }
                  disabled={this.state.isSending}
                  style={{
                    background: "transparent",
                  }}
                />
                <Input
                  type="email"
                  id="contact-email"
                  placeholder={
                    this.state.inputMailErr !== ""
                      ? this.state.inputMailErrMsg
                      : "Email"
                  }
                  className={
                    "mt-3 shadow-none rounded-0 " + this.state.inputMailErr
                  }
                  autoComplete="off"
                  autoCapitalize="none"
                  onChange={(e) =>
                    this.setState({
                      inputMailErr: "",
                      alertVisible: false,
                    })
                  }
                  disabled={this.state.isSending}
                  style={{
                    background: "transparent",
                  }}
                />
                <Input
                  type="textarea"
                  id="contact-message"
                  placeholder={
                    this.state.inputMessageErr !== ""
                      ? "Please enter your message"
                      : "Your message"
                  }
                  className={
                    "mt-3 shadow-none rounded-0 " + this.state.inputMessageErr
                  }
                  autoComplete="off"
                  onChange={(e) =>
                    this.setState({ inputMessageErr: "", alertVisible: false })
                  }
                  disabled={this.state.isSending}
                  style={{
                    background: "transparent",
                  }}
                />
                <Alert
                  color={this.state.alertClass}
                  className="rounded-0 mt-2 mb-2 text-md-center text-left "
                  isOpen={this.state.alertVisible}
                  toggle={(e) => this.setState({ alertVisible: false })}
                >
                  {this.state.alertMessage}
                </Alert>
                <div className="mt-3 text-right">
                  <Button
                    className="rounded-0 contact-form-btn mr-3"
                    color="dark"
                    outline
                    onClick={this.handleClear}
                    disabled={this.state.isSending}
                  >
                    <FontAwesomeIcon icon={faEraser} className="mr-2" />
                    Clear
                  </Button>
                  <Button
                    className="rounded-0 contact-form-btn main-btn-color"
                    onClick={this.handleSubmit}
                    disabled={this.state.isSending}
                  >
                    {this.state.isSending ? (
                      <Spinner animation="border" as="span" size="sm" />
                    ) : (
                      <>
                        <FontAwesomeIcon icon={faPaperPlane} className="mr-2" />
                        Submit
                      </>
                    )}
                  </Button>
                </div>
              </Col>
            </Row>
          </div>
        </Bounce>
        <Fade up>
          <h4 className="mt-5 mb-5 main-text-color">or contact me through</h4>
          <Row className="justify-content-center">
            <Col xs="3" md="2" lg="2" xl="1">
              <a href="tel:+639202410858">
                <img src={img_phone} alt="img_phone" width="55px" />
              </a>
            </Col>
            <Col xs="3" md="2" lg="2" xl="1">
              <a href="mailto:markanjogalisa05@gmail.com">
                <img src={img_google} alt="img_google" width="55px" />
              </a>
            </Col>
            <Col xs="3" md="2" lg="2" xl="1">
              <a
                href="https://www.linkedin.com/in/markgalisa/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={img_linkedin} alt="img_linkedin" width="55px" />
              </a>
            </Col>
            <Col xs="3" md="2" lg="2" xl="1">
              <a
                href="https://www.facebook.com/markanjo05/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={img_facebook} alt="img_facebook" width="55px" />
              </a>
            </Col>
          </Row>
        </Fade>
      </div>
    );
  }
}

export default Contact;
